import '../assets/styles/components/Footer.sass'
import React, { useState } from "react";
import InputMask from 'react-input-mask';

import Internit from '../assets/images/internit.png'

export default function Footer({ productId, projectName }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [sending, setSending] = useState(false);

  function checkData(e) {

    if (name != "" && email != "" && phone != "") {
      sendData(name, email, phone);
      setSending(true);
    } else {
      alert('Preencha todos os campos antes de enviar');
    }

  }

  function sendData(name, email, phone) {
    const now = new Date();
    const date = now.toLocaleDateString('pt-BR');
    const time = now.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
    const empreendimento = projectName || 'Mozak';

    fetch('/api/send-lead.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        nome: name,
        email: email,
        telefone: phone,
        data: date,
        hora: time,
        empreendimento: empreendimento,
      }),
    })
      .then(response => {
        if (!response.ok) throw new Error('Erro ao enviar');
        alert('Dados enviados com sucesso!');
        setName("");
        setEmail("");
        setPhone("");
        window.location.reload();
      })
      .catch(() => alert('Erro ao enviar. Tente novamente.'));
  }

  return (
    <footer className="footer" id="footer">

      <div className="form">

        <h2>Gostou?</h2>
        <h3>Agende uma reunião com um dos nossos especialistas
        </h3>

        <input type="text" onChange={(e) => setName(e.target.value)} placeholder="Nome" />
        <input type="email" onChange={(e) => setEmail(e.target.value)} placeholder="E-mail" />
        <InputMask type='text' mask="(99) 99999-9999" onChange={(e) => setPhone(e.target.value)} placeholder="Telefone" />

        <button
          onClick={checkData}
          disabled={sending}
          style={{ opacity: sending ? 0.5 : 1, cursor: sending ? 'not-allowed' : 'pointer' }}
          >
            {sending ? 'Enviando...' : 'Enviar'}
        </button>
      </div>

      <p className='creci'>CRECI RJ-008658/O</p>

      <a href='https://internit.com.br/' target='_blank' class="desenvolvido" rel="noreferrer">
        <span>Desenvolvido por</span>
        <img src={Internit} alt="Desenvolvido por Internit" />
      </a>

    </footer>
  );
}